import { render, staticRenderFns } from "./history-node.vue?vue&type=template&id=22fe96ef&scoped=true"
import script from "./history-node.vue?vue&type=script&lang=js"
export * from "./history-node.vue?vue&type=script&lang=js"
import style0 from "./history-node.vue?vue&type=style&index=0&id=22fe96ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe96ef",
  null
  
)

export default component.exports